module.exports = __webpack_public_path__ + "img/04155259000162.7de2e6d0.png";